import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

import { GisAddress } from '@components/quoting-flow/types/gis-types';
import { BASE_APIGEE_URL, GIS_URL_PATH } from '@constants/urls';
import { handleError } from '@utilities/http-utilities';

/**
 * Service for making HTTP requests to NW GIS endpoint
 */
@Injectable({ providedIn: 'root' })
export class GisService {
  // Services
  private readonly http = inject(HttpClient);

  // Apigee Service Logic
  private readonly baseUrl = `${BASE_APIGEE_URL}/${GIS_URL_PATH}`;
  private readonly DEFAULT_TIMEOUT = 30000; // 30 seconds aligns with api gateway default

  getTypeAheadAddress<AddressLookupResponse>(addressGlob: string): Observable<AddressLookupResponse> {
    const url = `${this.baseUrl}/suggests?text=${encodeURIComponent(addressGlob)}`;
    return this.http.get<AddressLookupResponse>(url).pipe(
      timeout(this.DEFAULT_TIMEOUT),
      catchError((error: HttpErrorResponse) => handleError(error)),
    );
  }

  formatSuggestedAddress(address: GisAddress): string {
    if (!address.addressLine || !address.lastLine) {
      return `${address.houseNumber} ${address.streetName}, ${address.city}, ${address.state} ${address.zip}, ${address.country}`;
    } else {
      return `${address.addressLine}, ${address.lastLine}, ${address.country}`;
    }
  }
}
